import React from 'react'

import { GuestCardLinkForm } from './GuestCardLinkForm'

/** Public guest-card-link route. Schools come from the form payload (served schools only). */
export const GuestCardLinkFormPage: React.FC = () => <GuestCardLinkForm />
